module.exports = __webpack_public_path__ + "img/arrow-up.247db69d.svg";